
export enum DeviceTypeCd {
	HANDHELD = 'Handheld',
	MOBILE_DEVICE_V_1 = 'MobileDeviceV1',
	NEXTEL = 'Nextel',
	PAGER = 'Pager'}
